let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l2uIb")).then(() => parcelRequire('9bvq1'));